import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { formatCurrency } from '../../../../../../common-utils/formatters';

function SellsCard({ year, data, loading = false }) {
  return (
    <div className="rounded-lg bg-gray-100 p-4">
      <h3 className="mb-2 text-lg font-semibold">{year}</h3>
      {loading ? (
        <Skeleton count={3} />
      ) : (
        <>
          <p className="mb-1">
            <b>Nombre de ventes :</b>
            {' '}
            {data.nbSales}
          </p>
          <p className="mb-1">
            <b>Prix moyen :</b>
            {' '}
            {formatCurrency(data.salesAveragePrice)}
          </p>
          <p>
            <b>Commission totale :</b>
            {' '}
            {formatCurrency(data.salesCommission)}
          </p>
        </>
      )}
    </div>
  );
}

export default SellsCard;
